<div class="row">
  <div class="col-sm-4"></div>
  <div class="col-sm-4">
    <div class="form-group">
      <label class="lblCls">
        Product Name
      </label>
      <input type="text" kendoTextBox class="form-control" name="productName" />

    </div>
    <div class="form-group">
      <label class="lblCls">
        Product Code
      </label>
      <input type="text" kendoTextBox class="form-control" name="productCode" />
    </div>
    <div class="form-group">
      <label class="lblCls">
        Product Description
      </label>
      <input type="text" kendoTextBox class="form-control" name="productDescription" />
    </div>
    
  </div>
  <div class="col-sm-4"></div>
</div>
